import React, { useState, useLayoutEffect, useRef, Fragment } from 'react';

import Tweet from '../Tweet/';
import DataContext from '../../contexts/data';
import ConfigContext from '../../contexts/config';
import BoxWipe from '../Transitions/BoxWipe';

import './tweetswrapper.scss';

const InnerTweetWrapper = ({ delay, results = [] }) => {
  const [previousIndex, setPreviousIndex] = useState(results.length - 1);
  const [activeIndex, setIndex] = useState(0);
  const [nextIndex, setNextIndex] = useState(1);
  const [imageActive, setImageActive] = useState(0);
  const [animationClass, setAnimationClass] = useState('');

  const loopLength = parseInt(delay);
  const timesRun = useRef(1);

  useLayoutEffect(() => {
    const nextTweet = () => {
      const newIndex = activeIndex + 1;
      setPreviousIndex((newIndex - 1) % results.length);
      setIndex(newIndex % results.length);
      setNextIndex((newIndex + 1) % results.length);
    };

    const nextImage = () => {
      const nextImage = imageActive === 0 ? 1 : 0;
      setImageActive(nextImage);
    };

    const startAnimation = () => {
      setAnimationClass('animation-active');
    };

    const timeline = () => {
      if (timesRun.current === Math.floor(loopLength / 2)) {
        // happen about halfway
        // and go to next
        nextImage();
        timesRun.current = timesRun.current + 1;
      } else if (timesRun.current === loopLength - 1) {
        // happen one second before the delay
        // and go to next
        startAnimation();
        timesRun.current = timesRun.current + 1;
      } else if (timesRun.current === loopLength) {
        // happen at the end
        nextTweet();
        nextImage();

        // At the end so reset
        timesRun.current = 1;
      } else {
        // Nothing happening. Go to next second
        timesRun.current = timesRun.current + 1;
      }
    };

    // Really simple timeline..
    const interval = setInterval(timeline, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [results, activeIndex]);

  return (
    <ConfigContext.Consumer>
      {config => {
        if (config.style === 'split-screen-animated') {
          return (
            <Fragment>
              <BoxWipe
                color1={config.animation_color_1}
                color2={config.animation_color_2}
                color3={config.animation_color_3}
                className={`${animationClass}`}
                onAnimationEnd={() => {
                  setAnimationClass('');
                }}
              />
              {results.map((res, index) => {
                return (
                  <Tweet
                    imageActive={imageActive}
                    key={index}
                    config={config}
                    item={res}
                    isPrevious={index === previousIndex}
                    isActive={index === activeIndex}
                    isNext={index === nextIndex}
                  />
                );
              })}
            </Fragment>
          );
        }

        return results.map((res, index) => {
          return (
            <Tweet
              imageActive={imageActive}
              key={index}
              config={config}
              item={res}
              isPrevious={index === previousIndex}
              isActive={index === activeIndex}
              isNext={index === nextIndex}
            />
          );
        });
      }}
    </ConfigContext.Consumer>
  );
};

export default ({ config }) => {
  return (
    <DataContext.Consumer>
      {({ results }) => (
        <div className="tweets-wrapper">
          <InnerTweetWrapper delay={config.duration} results={results} />
        </div>
      )}
    </DataContext.Consumer>
  );
};
